import {Directive, AfterViewInit, ElementRef, Renderer, Input,OnDestroy} from "@angular/core";

import {FOCUS_EVENT} from "../../util/constants/constants";

@Directive({
    selector: '[rxFocus]',
    exportAs:'focus'
})
export class RxFocusDirective implements AfterViewInit, OnDestroy {
   private element: Node;

    constructor(private renderer: Renderer, private elementRef: ElementRef) { this.element = this.elementRef.nativeElement as Node }

    ngAfterViewInit(): void {
        this.setFocus();
    }

    setFocus(): void {
        this.renderer.invokeElementMethod(
            this.element, FOCUS_EVENT, []);
    }

    ngOnDestroy(): void {
        this.element = undefined;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@rx/forms/focus/rx_focus_control_directive.ts